import { render, staticRenderFns } from "./MinkantuInput.vue?vue&type=template&id=5d703dfa&scoped=true"
import script from "./MinkantuInput.vue?vue&type=script&lang=js"
export * from "./MinkantuInput.vue?vue&type=script&lang=js"
import style0 from "./MinkantuInput.vue?vue&type=style&index=0&id=5d703dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d703dfa",
  null
  
)

export default component.exports